'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsUsagePage$() {
}
export { $c_Lpresto_CredentialsUsagePage$ as $c_Lpresto_CredentialsUsagePage$ };
$p = $c_Lpresto_CredentialsUsagePage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsUsagePage$;
/** @constructor */
function $h_Lpresto_CredentialsUsagePage$() {
}
export { $h_Lpresto_CredentialsUsagePage$ as $h_Lpresto_CredentialsUsagePage$ };
$h_Lpresto_CredentialsUsagePage$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 697460820;
});
$p.l = (function() {
  return "CredentialsUsagePage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "CredentialsUsagePage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dm = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().oA);
});
var $d_Lpresto_CredentialsUsagePage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsUsagePage$, "presto.CredentialsUsagePage$", ({
  FE: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_CredentialsUsagePage$ as $d_Lpresto_CredentialsUsagePage$ };
var $n_Lpresto_CredentialsUsagePage$;
function $m_Lpresto_CredentialsUsagePage$() {
  if ((!$n_Lpresto_CredentialsUsagePage$)) {
    $n_Lpresto_CredentialsUsagePage$ = new $c_Lpresto_CredentialsUsagePage$();
  }
  return $n_Lpresto_CredentialsUsagePage$;
}
export { $m_Lpresto_CredentialsUsagePage$ as $m_Lpresto_CredentialsUsagePage$ };
//# sourceMappingURL=presto.-Credentials-Usage-Page$.js.map
